import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { BootstrapStatuses } from '@cashier/cashier-model';

export const BOOTSTRAP_FEATURE_KEY = 'bootstrap';

export interface BootstrapState {
  status: BootstrapStatuses;
  error: string | null;
}

export const initialBoostrapState: BootstrapState = {
  status: BootstrapStatuses.IDLE,
  error: null,
};

export const bootstrapSlice = createSlice({
  name: BOOTSTRAP_FEATURE_KEY,
  initialState: initialBoostrapState,
  reducers: {
    startBootstrap: (state) => {
      state.status = BootstrapStatuses.LOADING;
    },
    bootstrapSucceeded: (state) => {
      state.status = BootstrapStatuses.READY;
    },
    bootstrapFailed: (state, action: PayloadAction<string>) => {
      state.status = BootstrapStatuses.FAILED;
      state.error = action.payload;
    },
  },
});

export const bootstrapReducer = bootstrapSlice.reducer;

export const { startBootstrap, bootstrapSucceeded, bootstrapFailed } =
  bootstrapSlice.actions;
